import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { VehicleParkingSpaceDto, vehicleParkingSpaceValidationSchema } from 'dtos'
import { Formik } from 'formik'

interface ParkingSpaceEditDialogProps {
  initialValues: VehicleParkingSpaceDto
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
  isLoading: boolean
}

export default function ParkingSpaceEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: ParkingSpaceEditDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={vehicleParkingSpaceValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Edit Parking Space</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.parkingSpace && errors.parkingSpace)}
                      fullWidth
                      helperText={touched.parkingSpace && errors.parkingSpace}
                      label='Parking Space'
                      name='parkingSpace'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.parkingSpace}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>All fields are required.</ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading || isSubmitting} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton color='primary' loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
